module.exports = __webpack_public_path__ + "img/i_mooc_phon.75492bf0.png";